import React, { useState, useCallback, useEffect } from 'react';
import ReactFlow, {
  ReactFlowProvider,
  Background,
  Controls,
  applyNodeChanges,
  applyEdgeChanges,
  addEdge,
  snapToGrid,
} from 'reactflow';
import 'reactflow/dist/style.css';
import NodeTypes from './nodeTypes';
import { Container, Col, Row, Button, Input } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_WORKFLOW, FETCH_WORKFLOW_LIST, FETCH_WORKFLOW_NODE_LIST, Get_Create_Bot_Model_List } from '../../slices/thunks';
import { set_bread_crum } from '../../slices/header/reducer';
import CustomEdge from './edges/CustomEdge';
import { useLocation } from 'react-router-dom';
import Loader from '../../Components/Common/Loader';
import { v4 as uuidv4 } from 'uuid';
import Global_Storage from './Global_Storage';

// const snapGrid = [20, 20];

let id = 0;
const getId = () => uuidv4();

const nodeTypesList = [
  { type: 'initializer_node', label: 'Initializer Node', iconClass: 'ri-play-line' },
  { type: 'input_node', label: 'Chat Input', iconClass: 'ri-question-answer-line' },
  { type: 'openai_chat_node', label: 'OpenAI', iconClass: 'ri-robot-line' },
  { type: 'output_node', label: 'Chat Output', iconClass: 'ri-file-line' },
  { type: 'end_node', label: 'End Node', iconClass: 'ri-file-line' },
  { type: 'conditional_node', label: 'Conditional Node', iconClass: 'ri-file-line' },
 
];

const icon_registry = {
  input_node:'ri-question-answer-line',
  openai_chat_node:'ri-robot-line',
  output_node:'ri-file-line'
}

function FlowCanvas() {
  

  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [nodeTypesList, setnodeTypesList] = useState([])
  const dispatch = useDispatch()
  const { node_list, workflow_loader ,params_list } = useSelector((state)=> state.WorkFlowBuilder)
  const {workflow_list , workflow_listing_loader} = useSelector((state)=>{
       return state.WorkFlowBuilder
    })
  const location = useLocation();
  const { Workflow_ID } = location.state || {};

  
  // Fetch the available node list .
  useEffect(()=>{
    dispatch(FETCH_WORKFLOW_NODE_LIST())
    dispatch(Get_Create_Bot_Model_List())
    dispatch(FETCH_WORKFLOW_LIST({ workflow_id: Workflow_ID }))
  },[Workflow_ID])


  useEffect(()=>{
     if(workflow_list?.workflow_data?.workflow_data){
      let {nodes, edges} = JSON.parse(JSON.stringify(workflow_list?.workflow_data?.workflow_data))
      nodes = nodes.map((element)=>{
            element.data.onDelete = handleDeleteNode
            return element

      })
      setNodes(nodes)
      setEdges(edges)
     }
  },[workflow_list])

  


  useEffect(() => {
    
    const node_list_temp =  node_list.map((ele)=>{
      return { id:ele.node_id , type: ele.node_name, label: ele.node_name, iconClass: icon_registry[ele.node_name] , node_data:ele }
    })
    setnodeTypesList(node_list_temp)
   
  }, [node_list])
  
 const create_flow = ()=>{
      dispatch(CREATE_WORKFLOW({ nodes , edges ,workflow_id:Workflow_ID , params:params_list }))
 }

  const onNodesChange = useCallback((changes) => {
    setNodes((nds) => applyNodeChanges(changes, nds));
  }, []);

  const onEdgesChange = useCallback((changes) => {
    setEdges((eds) => applyEdgeChanges(changes, eds));
  }, []);

  const edgeTypes = {
  customEdge: CustomEdge,
};

  const onConnect = useCallback(
    (connection) => {
      // console.log(connection)
      const sourceNode = nodes.find((n) => n.id === connection.source);
      const targetNode = nodes.find((n) => n.id === connection.target);

      if (!sourceNode || !targetNode) return;

      // if (sourceNode.type === targetNode.type) {
      //   alert(`Cannot connect nodes of the same type: "${sourceNode.type}"`);
      //   return;
      // }

      // setEdges((eds) => addEdge( { ...connection, type: 'customEdge' }, connection, eds));
      setEdges((eds) => addEdge({ ...connection, type: 'customEdge',  animated: true  }, eds));

    },
    [nodes]
  );

  const handleDeleteNode = useCallback((nodeId) => {
    setNodes((nds) => nds.filter((n) => n.id !== nodeId));
    setEdges((eds) => eds.filter((e) => e.source !== nodeId && e.target !== nodeId));
  }, []);

  const handleDeleteEdge = useCallback((event, edge) => {
    event.stopPropagation(); 
    const confirmDelete = window.confirm('Do you want to delete this edge?');
    if (confirmDelete) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
    }
  }, []);
  
  // const handleDeleteEdge = useCallback((event, edge) => {
  //   event.stopPropagation(); 
  //   setEdges((eds) => eds.filter((e) => e.id !== edge.id));
  // }, []);

  const addNode = (type , node) => {
    // console.log(node);
    
    const newId = getId();
    const newNode = {
      id: newId,
      node_id:node.node_id,
      type:node.type,
      position: {
        x: Math.random() * 250 + 100,
        y: Math.random() * 250 + 100,
      },
      data: {
        label:node.type,
        onDelete: handleDeleteNode,
        selectedNodeId, 
        node_data:node.node_data
      },

    
    };
    setNodes((nds) => [...nds, newNode]);
  };

  const onNodeClick = (event, node) => {
    setSelectedNodeId(node.id);
    // console.log(nodes);
    // console.log(edges);
    // create_flow()
    
    
  };

  // 🔧 Inject selectedNodeId dynamically
  const nodesWithSelection = nodes.map((node) => ({
    ...node,
    data: {
      ...node.data,
      selectedNodeId,
    },
  }));


  useEffect(()=>{
    dispatch(set_bread_crum({ title:"Work Flow"  , pageTitle:"Dashboard"  }))

    return ()=>{
    dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
        
    }
  },[])

  return (
    <React.Fragment>
      <h1>  </h1>
      <div className="page-content top-p-80">
        <Container fluid>
          <Row>
            <Col>
            <div className='workflow_heeading'>
              <h3>{workflow_list?.Workflow_Title}</h3>
            </div>
            </Col>
            <Col>
            <div className='btn-Wrap_workflow'>
              <Button onClick={()=>{
                create_flow()
              }} >Compile & Start Work Flow</Button>
              {/* <Button>Button secondary</Button> */}
            </div>
            </Col>
          </Row>
          <Row>
            <Col>
            
              <ReactFlowProvider>
                <div style={{ display: 'flex', height: '80vh' }}>
                  {/* Sidebar */}
                  <div
                    className="sidebar_flow"
                    style={{
                      width: '200px',
                      padding: '1rem',
                      borderRight: '1px solid #ccc',
                      background: '#f9f9f9',
                    }}
                  >
                    <div className="sidebar_heading mb-3">
                      <h3>
                        <i className="ri-side-bar-line"></i> Components
                      </h3>
                    </div>
                    {nodeTypesList.map((node) => (
                      <button
                        key={node.type}
                        style={{
                          display: 'block',
                          marginBottom: '10px',
                          width: '100%',
                          textAlign: 'left',
                        }}
                        onClick={() => addNode(node.type , node)}
                      >
                        <i className={node.iconClass} style={{ marginRight: '5px' }}></i>
                        {node.label}
                      </button>
                    ))}
                    <Global_Storage nodes={nodes} edges={edges} />
                  </div>

                  {/* Flow Canvas */}
                  <div style={{ flexGrow: 1 }}>
                    {workflow_loader ? <Loader/>:<ReactFlow
                      nodes={nodesWithSelection}
                      edges={edges}
                      onNodesChange={onNodesChange}
                      onEdgesChange={onEdgesChange}
                      onConnect={onConnect}
                      nodeTypes={NodeTypes}
                      edgeTypes={edgeTypes}
                      // snapToGrid={true}
                      // snapGrid={snapGrid}
                      fitView
                      onNodeClick={onNodeClick}
                      onEdgeClick={handleDeleteEdge}
                      onPaneClick={() => setSelectedNodeId(null)}
                    >
                      <Background
                        variant="dots"
                        gap={12}
                        size={1}
                        style={{ backgroundColor: '#f4f4f5' }}
                      />
                      <Controls />
                    </ReactFlow>}
                  </div>
                </div>
              </ReactFlowProvider>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default FlowCanvas;
